// eslint-disable-next-line jira/filename-case
import React, { type ComponentType } from 'react';
import { GADGET_DEFAULT_HEIGHT } from '@jira/global-pages__dashboard-common/src/constants.tsx';
import type { ReactGadgetProps } from '@jira/global-pages__dashboard-react-gadgets-common/src/types.tsx';
import { FilterResultsIssueTableSkeleton } from '@jira/platform__skeletons/src/ui/dashboard/components/filter-results-issue-table.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint, type PreloadPriority } from '@atlassian/react-loosely-lazy';
import type { Cleanup } from '@atlassian/react-loosely-lazy/cleanup';
import type { IssueTableGadgetData } from '../../types.tsx';

const LazyIssueTableGadgetView = lazyForPaint<
	ComponentType<ReactGadgetProps<IssueTableGadgetData>>
>(() => import(/* webpackChunkName: "async-react-filter-results-gadget-view" */ './main.tsx'));

export const IssueTableGadgetView = ({
	customSkeletonHeightInPx,
	...props
}: ReactGadgetProps<IssueTableGadgetData>): React.JSX.Element => (
	<Placeholder
		name="filter-results-gadget-view"
		fallback={
			<FilterResultsIssueTableSkeleton
				height={`${customSkeletonHeightInPx ?? GADGET_DEFAULT_HEIGHT}px`}
			/>
		}
	>
		<LazyIssueTableGadgetView customSkeletonHeightInPx={customSkeletonHeightInPx} {...props} />
	</Placeholder>
);

export const preload: (priority?: PreloadPriority) => Cleanup = LazyIssueTableGadgetView.preload;
